var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "uuid-e4410961-1a87-48b6-9d53-14df25c1a747",
    "data-name": "Livello 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 595 595",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .uuid-5e5b5a4a-4b45-4437-9153-f8161699dec8 {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 33px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "uuid-13091be5-dc28-4402-ad5e-8b18e9fea231",
    "data-name": "Icon feather-loader"
  }, /*#__PURE__*/React.createElement("path", {
    id: "uuid-7f0e8843-0324-44cb-a263-9bbd6deba797",
    "data-name": "Tracciato 208",
    className: "uuid-5e5b5a4a-4b45-4437-9153-f8161699dec8",
    d: "M297.5,16.5v112.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-58a35f77-0dc1-4795-ad03-586c28902fa8",
    "data-name": "Tracciato 209",
    className: "uuid-5e5b5a4a-4b45-4437-9153-f8161699dec8",
    d: "M297.5,466.1v112.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-a4630f57-aa3d-45d1-865b-c7a7bb5970d5",
    "data-name": "Tracciato 210",
    className: "uuid-5e5b5a4a-4b45-4437-9153-f8161699dec8",
    d: "M98.83,98.83l79.52,79.52"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-f23ad833-0791-438f-9194-591889c393a1",
    "data-name": "Tracciato 211",
    className: "uuid-5e5b5a4a-4b45-4437-9153-f8161699dec8",
    d: "M416.64,416.64l79.43,79.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-d4eae203-347e-4325-b446-f3bb9a3b28dc",
    "data-name": "Tracciato 212",
    className: "uuid-5e5b5a4a-4b45-4437-9153-f8161699dec8",
    d: "M16.5,297.5h112.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-7fc4a570-2096-4a7c-9685-939cab3e768f",
    "data-name": "Tracciato 213",
    className: "uuid-5e5b5a4a-4b45-4437-9153-f8161699dec8",
    d: "M466.1,297.5h112.4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-12c656c0-e550-464a-8c26-0c7df3a88f38",
    "data-name": "Tracciato 214",
    className: "uuid-5e5b5a4a-4b45-4437-9153-f8161699dec8",
    d: "M98.83,496.07l79.52-79.43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "uuid-46065e3f-318f-4926-99da-b5ba44b6b413",
    "data-name": "Tracciato 215",
    className: "uuid-5e5b5a4a-4b45-4437-9153-f8161699dec8",
    d: "M416.64,178.36l79.43-79.52"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.397c93e842d2bbe9d6c803c229a7a096.svg";
export { ForwardRef as ReactComponent };